import API from '@apis/API';
import { PageResponse } from '@models/api';

export type RegionResponse = {
  regionId: number;
  regionCode: string;
};
export const getAllRegions = async () =>
  (await API.get<PageResponse<RegionResponse>>(`/v1/regions`)).data;
